import { useRootStore } from '~/store/root'

export default defineNuxtRouteMiddleware(async () => {
  const { $pinia } = await useNuxtApp()
  if (!useRootStore($pinia).authUser) {
    showError({
      message: 'You are not connected',
      statusCode: 403
    })
  }
})
